<template>
	<div>
		<div class="main">
			<p class="title">基本信息</p>
			<ul>
				<li>昵称：<input type="" name="" v-model="userInfo.userNickname" value="" placeholder="请输入您的昵称" /></li>
				<li class="inputImg">头像：
					<div class="borderImg">
						<img v-if="upFileImgHeader" :src="upFileImgHeader" class="inputImg_img" >
						<img v-else src="../../../assets/img/comm/noSetUserImg.png" class="inputImg_img" >
						<p class="showHand">
							编辑资料
							<el-upload style="position: absolute;width: 100%;height: 100%;background-color: red;
							top: 0;left: 0;opacity: 0;"
							:action="requestUrl"
							:show-file-list="false"
							:on-success="handleAvatarSuccess">
							  <i  class="el-icon-plus avatar-uploader-icon" style="position: absolute;width: 100%;height: 100%;background-color: red;
							top: 0;left: 0;"></i>
							</el-upload>
							<!-- <input type="file" multiple @change="upload" -->
							<!-- class="inputImg_al showHand" style="position: absolute;top: 0;left: -120px;"> -->
						</p>
					</div>
				<li>
				<li>姓名：<input type="" name="" v-model="userInfo.userName" value="" placeholder="请输入您的姓名" /></li>
				<li class="sex">
					性别：
					<div class="showHand">
						<img :src="sexStatus==0?require('../../../assets/img/comm/sexSelected.png')
							:require('../../../assets/img/comm/sexSelect.png')" @click="sexSub(0)">
						<span>男</span>
					</div>
					<div class="showHand">
						<img :src="sexStatus==1?require('../../../assets/img/comm/sexSelected.png')
							:require('../../../assets/img/comm/sexSelect.png')" @click="sexSub(1)">
						<span>女</span>
					</div>
				</li>
				<li class="birth">生日：
					<div>
						<select name="" class="select" @change='handleYearSel'>
							<option :selected="index==selYadr?'selected':''"
							 v-for="(item,index) in yearArr" :key="index">{{item}}</option>
						</select>
						<span>年</span>
					</div>
					<div>
						<select name=""  class="select" @change="handleMonthSel">
							<option value="" :selected="index==selMonth?'selected':''" v-for="(item,index) in 12" :key="index">{{index+1}}</option>
						</select>
						<span>月</span>
					</div>
					<div>
						<select name="" value="2" class="select" @change="handleDaySel">
							<option :selected="index==selDays?'selected':''" v-for="(item,index) in days" :key="index">{{item}}</option>
						</select>
						<span>日</span>
					</div>
				</li>
				<li>电话：<input type="number" name="" v-model="userInfo.userPhone" value="" placeholder="请输入手机号" maxlength="11"
						oninput="if(value.length>11)value=value.slice(0,11)" /></li>
				<button type="button" class="showHand" @click="throttle(editSubmit,1500)">保存</button>
				
				
				
			</ul>
			<!-- <img src="" > -->
		</div>
	</div>
</template>

<script>
	let _self;
	import { fileUpload,appCUserFindById } from '@/api/comm.js'
	import { upAppCUser,onuploadimg } from "@/api/personalInfo.js"
	export default {
		name: "",
		data() {
			return {
				requestUrl:this.$store.getters.upImgUrl,
				// 性别选择
				sexStatus:true,
				//年份
				yearArr: null,
				// 选择的年
				selYadr: 0,
				// 选择的月
				selMonth: 0,
				// 当前月天数
				days: null,
				// 选择的天数
				selDays: 0,
				//是否允许请求
				isrequest:true,
				// 头像
				upFileImgHeader:null,
			}
		},
		beforeCreate() {
			_self = this;
		},
		created() {
			
			// 用户信息处理===用户信息传递
			_self.userInfo=this.getUInfo();
			// console.log("用户信息",_self.userInfo);
			// 定义用户性别
			_self.sexStatus=_self.userInfo.userSex;
			// 定义用户头像
			_self.upFileImgHeader=_self.userInfo && _self.userInfo.userImg?_self.userInfo.userImg:'';
			
			
			if(_self.userInfo && _self.userInfo.userBirthday){
				// 处理显示的年月日
				_self.handleEditYmD();
			}else{
				// 计算年份
				_self.year();
			}
		},
		// 方法集
		methods: {
			// 图片上传成功
			handleAvatarSuccess(res){
				if(res){
					_self.upFileImgHeader=res;
				}
			},
			
			
			// 处理显示的年月日
			handleEditYmD(){
				let timeInfo=_self.transformTimestamp(_self.userInfo.userBirthday);
				
				
				let newArr =timeInfo.split('-')
				console.log('处理的年月日===',newArr);
				// 计算年份
				_self.year(newArr[0],parseInt(newArr[2].slice(0,2)));
				// 定义月份
				_self.selMonth=parseInt(newArr[1])-1;
				
				// 计算月
				// _self.handleJsDays();
			},
			// 时间转换
			transformTimestamp(timestamp){
				if(!timestamp)return;
				let a = new Date(timestamp).getTime();
				const date = new Date(a);
				const Y = date.getFullYear() + '-';
				const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
				const D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + '  ';
				const h = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':';
				const m = (date.getMinutes() <10 ? '0'+date.getMinutes() : date.getMinutes()) ;
				// const s = date.getSeconds(); // 秒
				const dateString = Y + M + D + h + m;
				return dateString;
			},
			
			// 性别选择状态
			sexSub(val){
				// 当前的状态取反
				_self.sexStatus = val;
			},
			//修改接口
			editSubmit(){
				// 是否允许请求
				if(!_self.isrequest) return;
				_self.isrequest=false;
				// 判断手机号是否为空或者是否满足11位
				// 正则验证手机号
				let myreg=/^[1][0-9]{10}$/;
				if (!myreg.test(_self.userInfo.userPhone)) {
					_self.$eror('请输入正确的手机号')
					_self.isrequest=true;
					return false;
				}else{
					
					// 转移标准时间
					let birthdayTime = _self.yearArr[_self.selYadr] + '-' + (_self.selMonth-0+1) + '-' + _self.days[_self.selDays];
					// 定义一个新的字段  赋值
					// let birthdayTime = new Date(newTime);
					
					
					// _self.isrequest=true;
					// return false;
					//修改信息接口
					upAppCUser({
						userId:_self.userInfo.userId,
						userSex:_self.sexStatus==1?1:0,
						userBirthday:birthdayTime,
						userImg:_self.upFileImgHeader||'',
						userName:_self.userInfo.userName,
						userPhone:_self.userInfo.userPhone,
						userNickname:_self.userInfo.userNickname
					}).then(res=>{
						if(res.code==200){
							// 定义当前页面的userInfo
							
							appCUserFindById({
								userId:_self.userInfo.userId
							}).then(tes=>{
								if(tes.code==200){
									// 接口获取成功
									
									
									//定义本地存储的userInfo
									localStorage.setItem('userInfo',JSON.stringify(tes.data));
									// 传递给topBar==用户信息
									_self.$EventBus.$emit('userEditInfo',tes.data);
									// 定义当前用户信息
									_self.$set(_self,'userInfo',tes.data);
									
									// 提示修改成功
									_self.$message({
										message:'修改成功',
										type:'success'
									})
								}
								// 允许再次请求
								_self.isrequest=true;
							})
						}else{
							_self.$eror('修改失败')
							// 允许再次请求
							_self.isrequest=true;
						}
					})
				}
			},
			
			
			
			// 计算年份
			year(val,days) {
				console.log('计算年===收到的年份》',[val,days]);
				// 定义一个新数组
				let newArr = [];
				let year = new Date();
				let newNUm=0;
				// 循环遍历当前年份的前100年
				for (let i = year.getFullYear() - 100; i <= year.getFullYear(); i++) {
					newNUm++;
					
					newArr.push(i)
					if(val== i){
						// 选择的年
						_self.selYadr=newNUm-1;
						console.log('找到年了====',i);
					}
				}
				// 赋值给data中定义的值
				_self.yearArr = newArr;

				// 计算当前月的日子数组
				_self.handleJsDays(days);
			},
			// 选择了===年份
			handleYearSel(e) {
				// 定义选择的下标
				_self.selYadr = e.target.selectedIndex;
				// 计算当月的日子
				_self.handleJsDays();
			},
			// 选择了===月份
			handleMonthSel(e) {
				// 定义选择的下标
				_self.selMonth = e.target.selectedIndex;
				// 计算当月的日子
				_self.handleJsDays();
			},
			//选择了===天
			handleDaySel(e){
				// 定义选择的下标 
				_self.selDays = e.target.selectedIndex;
			},
			// 计算当月日子
			handleJsDays(val) {
				let timeAll = new Date(_self.yearArr[_self.selYadr], _self.selMonth + 1, 0);
				let newArr = [];
				for (let i = 1; i <= timeAll.getDate(); i++) {
					newArr.push(i)
				}
				_self.days = newArr;
				
				// 定义显示的日子
				if(val){
					// 定义号
					_self.selDays=val-0-1;
				}
			}
		},
		// 组件集
		components: {

		},
		mounted() {

		},
		watch: {

		},
		computed: {

		},
		// 过滤器
		filters: {

		},
		// 实例销毁
		destroyed() {

		},
		// 页面跳转信息
		beforeRouteEnter(to, from, next) {
			// next();
			// 判断是否登录===登录，允许进入||未登录，返回登陆页
			let info = localStorage.getItem('userInfo');
			info ? next() : next('/Login')
		},
	}
</script>

<style scoped>
	.main {
		width: 100%;
		background: rgba(255, 255, 255, 0.72);
		padding: 20px 30px;
		box-sizing: border-box;
		margin-bottom: 45px;
	}

	.title {
		font-size: 16px;
		font-weight: 400;
		color: #e62129;
		letter-spacing: 2px;
		width: 72px;
		border-bottom: 2px solid #e62129;
		padding-bottom: 5px;
		box-sizing: border-box;
	}

	.main ul {
		padding: 38px 30px;
		box-sizing: border-box;
	}

	.main ul li {
		font-size: 16px;
		font-weight: 400;
		color: #666666;
		letter-spacing: 2px;
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-bottom: 25px;
	}

	.main ul li input {
		width: 300px;
		height: 36px;
		background: #ffffff;
		border: 1px solid #cccccc;
		font-size: 16px;
		font-weight: 400;
		color: #333333;
		letter-spacing: 2px;
		margin-left: 20px;
		padding-left: 10px;
		box-sizing: border-box;
	}

	.borderImg {
		width: 125px !important;
		height: 125px !important;
		border: 2px solid #cccccc;
		margin-left: 20px;
		padding: 3px;
		box-sizing: border-box;position: relative;
	}

	.inputImg_img {
		width: 120px !important;
		height: 115px !important;
		display: block;
	}

	.inputImg_al {
		/* width: 120px !important; */
		height: 30px !important;
		opacity: 0;
	}

	.inputImg p {
		position: absolute;
		bottom: 3px;
		left: 3px;
		width: 114px;
		height: 24px;
		background: rgba(0, 0, 0, 0.45);
		font-size: 16px;
		color: #ffffff;
		letter-spacing: 2px;
		padding: 2px 18px;
		box-sizing: border-box;
	}

	.sex {
		display: flex;
		flex-direction: row;
	}
	.sex div{
		margin-left: 20px;
	}
	.sex img{
		width: 20px;
		height: 20px;
		margin-right: 10px;
	}

	.select {
		width: 100px;
		height: 36px;
		background: #ffffff;
		border: 1px solid #cccccc;
		margin-right: 10px;
		font-size: 16px;
		color: #333333;
		letter-spacing: 2px;
		padding-left: 10px;
		box-sizing: border-box;
	}

	.birth {
		display: flex;
		flex-direction: row;
	}

	.birth div {
		margin-right: 20px;
	}

	.birth div:nth-child(1) {
		margin-left: 20px;
	}

	button {
		width: 72px;
		height: 30px;
		background: #e62129;
		font-size: 14px;
		font-weight: 400;
		color: #ffffff;
		letter-spacing: 1px;
	}
</style>
